import React from "react";
import Footer from './Footer';
import TopNav from "./TopNav";
import Breadcrumbs from "../Hooks/Breadcrumbs";
import MyChatbot from "../components/chatbot/MyChatbot";

const Layout = ({ children, fillHeight }) => {
  return (
    <>
      <TopNav />
      <div className={`tn-page-wrapper${fillHeight ? " tn-page-wrapper--fill" : ""}`}>
        <div className={`tn-page-content${fillHeight ? " tn-page-content--fill" : ""}`}>
          <Breadcrumbs />
          {children}
        </div>
      </div>
      <Footer />
      <MyChatbot />
    </>
  );
};

export default Layout;
